import api from './api';

export interface Release {
  tag: string;
  name: string;
  body: string;
  publishedAt: string;
  url: string;
}

export async function getChangelog(): Promise<Release[]> {
  const { data } = await api.get<{ success: boolean; data: Release[] }>(
    '/changelog',
  );
  return data.data;
}
